import sessionListHistoryIcon from '@/assets/icons/session-list-history.svg';
import tradeHistoryIcon from '@/assets/icons/trade-history.svg';
import watchlistHistoryIcon from '@/assets/icons/watchlist-history.svg';

const ICONS = Object.freeze({
  'session-history': sessionListHistoryIcon,
  'trade-history': tradeHistoryIcon,
  'watchlist-history': watchlistHistoryIcon,
});

const AVAILABLE_ICONS = Object.keys(ICONS);

export default {
  props: {
    icon: {
      type: String,
      required: true,
      validator(value) {
        return AVAILABLE_ICONS.includes(value);
      },
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconSrc() {
      return ICONS[this.icon];
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-empty-state/market-empty-state.js